import { render } from "./xlptgaojingdetail.vue?vue&type=template&id=2076d1ee&scoped=true&ts=true"
import script from "./xlptgaojingdetail.vue?vue&type=script&lang=ts"
export * from "./xlptgaojingdetail.vue?vue&type=script&lang=ts"

import "./xlptgaojingdetail.vue?vue&type=style&index=0&id=2076d1ee&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2076d1ee"]])

export default __exports__